import { InfoTooltipIcon } from "./InfoTooltipIcon"

export const RatingProfileInfoTooltipIcon = () => {
  return (
    <InfoTooltipIcon label="Målingsprofilen er basert på næringskoden til virksomheten, på 4-sifret nivå. Målingsprofilen inneholder måltallene som virksomheten måles opp mot. Forslag til målingsprofil kommer opp automatisk. Kontroller at målingsprofilen stemmer med næringskoden (på 4-sifret nivå). Det er viktig at det velges riktig målingsprofil, hvis ikke blir virksomheten målt mot feil måltall. Da blir målingen ugyldig." />
  )
}
